import React from 'react';
import styles from './Typography.scss';
import cx from 'classnames';
const cardBase = {
  [styles['card']]: true
};

const cardTitleBase = {
  [styles['card-title']]: true,
  [styles['font-frutiger-lt-light']]: true,
  ...cardBase
};

const cardContentBase = {
  [styles['card-content']]: true,
  [styles['font-frutiger-lt-roman']]: true,
  ...cardBase
};

export const Typography = props => (
  <span className={props.classes}>{props.children}</span>
);
export const CardTitle = props => {
  return <Typography classes={cx(cardTitleBase)}>{props.children}</Typography>;
};

export const CardContent = props => {
  return (
    <Typography classes={cx(cardContentBase)}>{props.children}</Typography>
  );
};

export const SubtitleSmall = props => (
  <Typography
    classes={cx({
      [styles['subtitle-small']]: true,
      [styles['font-frutiger-lt-roman']]: true
    })}
  >
    {props.children}
  </Typography>
);

export const ContentData = props => (
  <Typography
    classes={cx({
      [styles['content-data']]: true,
      [styles['font-frutiger-lt-light']]: true
    })}
  >
    {props.children}
  </Typography>
);

export const SubtitleTool = props => (
  <Typography
    classes={cx({
      [styles['subtitle-tool']]: true,
      [styles['font-frutiger-lt-light']]: true
    })}
  >
    {props.children}
  </Typography>
);

export const Amount = props => (
  <Typography classes={styles['amount-font']}>{props.children}</Typography>
);
